import { render } from "./AddressModal.vue?vue&type=template&id=253c4d20"
import script from "./AddressModal.vue?vue&type=script&lang=js"
export * from "./AddressModal.vue?vue&type=script&lang=js"

import "./AddressModal.vue?vue&type=style&index=0&id=253c4d20&lang=scss"
script.render = render

export default script